import React from 'react';
import { Box, Typography } from '@mui/material';

const DubbingTabs = ({ activeTab, onTabChange, activeJobsCount, tabFilters = [], allJobs = [] }) => {
  const getCounts = (filter) => {
    if (!filter) return allJobs.length;
    if (filter === 'active') {
      return allJobs.filter(j => ['pending_approval', 'approved', 'pending', 'processing'].includes(j.status)).length;
    }
    if (filter === 'completed') return allJobs.filter(j => j.status === 'completed').length;
    if (filter === 'failed') return allJobs.filter(j => j.status === 'failed' || j.status === 'error').length;
    return 0;
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
      {tabFilters.map((tab, i) => {
        const count = getCounts(tab.filter);
        const isActive = activeTab === i;
        return (
          <Box
            key={i}
            onClick={(e) => onTabChange(e, i)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              px: 1.75,
              py: 0.7,
              borderRadius: '7px',
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
              fontSize: '13px',
              fontWeight: isActive ? 600 : 500,
              backgroundColor: isActive ? '#FFFFFF' : 'rgba(255,255,255,0.05)',
              color: isActive ? '#000000' : 'rgba(255,255,255,0.5)',
              border: isActive ? 'none' : '1px solid rgba(255,255,255,0.08)',
              transition: 'all 0.15s ease',
              userSelect: 'none',
              '&:hover': {
                backgroundColor: isActive ? '#F0F0F0' : 'rgba(255,255,255,0.09)',
                color: isActive ? '#000000' : '#FFFFFF',
              },
            }}
          >
            {tab.label}
            <Typography
              component="span"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '11px',
                fontWeight: 600,
                px: 0.6,
                py: 0.1,
                borderRadius: '4px',
                backgroundColor: isActive ? 'rgba(0,0,0,0.12)' : 'rgba(255,255,255,0.08)',
                color: isActive ? '#000000' : 'rgba(255,255,255,0.4)',
                lineHeight: 1.5,
                minWidth: '16px',
                textAlign: 'center',
              }}
            >
              {count}
            </Typography>
            {tab.filter === 'active' && activeJobsCount > 0 && (
              <Box sx={{
                width: 6, height: 6, borderRadius: '50%',
                backgroundColor: isActive ? '#000' : '#3B82F6',
                animation: 'pulse 1.5s ease-in-out infinite',
                '@keyframes pulse': {
                  '0%, 100%': { opacity: 1 },
                  '50%': { opacity: 0.3 },
                },
              }} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default DubbingTabs;
